import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VSelect,{staticClass:"pt-5",attrs:{"items":_vm.analysisTypesDrp,"item-text":"name","item-value":"id"},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }